module.exports = __webpack_public_path__ + "static/img/case9.6878bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/case9.png
// module id = BF/3
// module chunks = 1